module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._h('div', {
    staticClass: "topbar"
  }, [_vm._h('div', {
    staticClass: "clearfix main-wrap"
  }, [_vm._h('a', {
    staticClass: "pull-left img-back",
    attrs: {
      "href": "javascript:window.history.go(-1)"
    }
  }, ["返回"]), " ", _vm._h('h1', [_vm._s(_vm.getPushDetailInfo.pustType == 1 ? '系统通知' : '消息通知')]), " ", _vm._h('span', {
    staticClass: "pull-right icon-right",
    on: {
      "click": function($event) {
        _vm.isHideAlert = false
      }
    }
  }, ["删除"])]), " ", _vm._h('div', {
    staticClass: "liner"
  })]), " ", _vm._h('div', {
    staticClass: "main-page bg-white",
    staticStyle: {
      "min-height": "600px"
    }
  }, [_vm._h('div', {
    staticClass: "padding-15"
  }, [_vm._h('div', [_vm._s(_vm.getPushDetailInfo.pushContent)])]), " ", _vm._h('div', {
    staticClass: "liner margin-15"
  }), " ", _vm._h('p', {
    staticClass: "gray margin-x-15 text-right font-14"
  }, [_vm._s(_vm.getPushDetailInfo.pushDateString)]), " ", _vm._h('div', {
    staticClass: "margin-15"
  }, [_vm._h('span', {
    staticClass: "margin-15 gray"
  }, ["孩子信息"]), " ", _vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('ul', {
    staticClass: "list-group-item tinny"
  }, [_vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "clearfix  group-txt"
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["姓名"]), " ", _vm._h('span', {
    staticClass: "pull-right gray"
  }, [_vm._s(_vm.kidsDetail.invstudentName)])]), " ", _vm._h('div', {
    staticClass: "liner"
  })]), " ", _vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "clearfix  group-txt"
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["性别："]), " ", _vm._h('span', {
    staticClass: "pull-right gray"
  }, [_vm._s(_vm.kidsDetail.sex)])]), " ", _vm._h('div', {
    staticClass: "liner"
  })]), " ", _vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "clearfix group-txt"
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["生日:"]), " ", _vm._h('span', {
    staticClass: "pull-right gray"
  }, [_vm._s(_vm.kidsDetail.birthdayString)])]), " ", _vm._h('div', {
    staticClass: "liner"
  })]), " ", _vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "clearfix group-txt",
    attrs: {
      "href": "#"
    }
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["学校:"]), " ", _vm._h('span', {
    staticClass: "pull-right gray"
  }, [_vm._s(_vm.kidsDetail.szxx)])]), " ", _vm._h('div', {
    staticClass: "liner"
  })]), " ", _vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "clearfix group-txt"
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["年级:"]), " ", _vm._h('span', {
    staticClass: "pull-right gray"
  }, [_vm._s(_vm.kidsDetail.grade)])]), " ", _vm._h('div', {
    staticClass: "liner"
  })]), " ", _vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "clearfix group-txt"
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["班级:"]), " ", _vm._h('span', {
    staticClass: "pull-right gray"
  }, [_vm._s(_vm.kidsDetail.className)])]), " ", _vm._h('div', {
    staticClass: "liner"
  })])])]), " ", (_vm.getPushDetailInfo.isAgree == 0) ? _vm._h('div', {
    staticClass: "margin-15 padding-15 text-center"
  }, [_vm._h('span', {
    staticClass: "button-pill-circle",
    on: {
      "click": function($event) {
        _vm.agreeParentsMsg()
      }
    }
  }, ["同意"])]) : _vm._e(), " ", (_vm.getPushDetailInfo.isAgree == 1) ? _vm._h('div', {
    staticClass: "text-center"
  }, [_vm._h('span', {
    staticClass: "padding-15"
  }, ["已同意申请"])]) : _vm._e()]), " ", _vm._h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHideAlert),
      expression: "!isHideAlert"
    }],
    staticClass: "maskdiv",
    on: {
      "click": function($event) {
        _vm.isHideAlert = true
      }
    }
  }, [_vm._h('div', {
    staticClass: "popover",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._h('div', {
    staticClass: "pop-wrap text-center"
  }, [_vm._h('p', {
    staticClass: "padding-15"
  }, ["您确定要删除本条消息吗？"]), " ", _vm._h('div', {
    staticClass: "liner margin-15"
  }), " ", _vm._h('div', {
    staticClass: "clearfix"
  }, [_vm._h('div', {
    staticClass: "col-xs-6 blue"
  }, [_vm._h('a', {
    staticClass: "blue  block",
    staticStyle: {
      "border-right": "1px solid #ddd"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deletePushMsg()
      }
    }
  }, ["是"])]), " ", _vm._h('div', {
    staticClass: "col-xs-6 blue"
  }, [_vm._h('a', {
    staticClass: "blue",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isHideAlert = true
      }
    }
  }, ["不是"])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.1@vue-loader/lib/template-compiler.js?id=data-v-58646133!./~/.10.0.1@vue-loader/lib/selector.js?type=template&index=0!./src/views/user/NewsDetailInvitation.vue
// module id = 206
// module chunks = 1